import {
  BlueBirdTheme, Button, Radio, RadioGroup, Scrollbar, SearchBar, Typography,
} from "@kitbird/core";
import { ReactNode, useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../Modal";

const { danger, gray, primary } = BlueBirdTheme.colors;

const Wrapper = styled.div<{ $isError?: boolean }>`
  border: 1px solid ${({ $isError }) => ($isError ? danger[500] : "transparent")};
  border-radius: 4px;
  background-color: ${primary[100]};

  padding: 12px 16px 12px 16px;
  border-radius: 4px;

  display: grid;
  grid-template-columns: 24px auto 80px;
  gap: 16px;
  align-items: center;

  button {
    min-height: 32px;
    padding: 0 28px !important;
  }
`;

const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 70vh;
`;

const FilterContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 34px;
`;

const WrapperList = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
  cursor: pointer;
`;

const WrapperBox = styled.div<{ $isSelect: boolean }>`
  width: 100%;
  border: 1px ${({ $isSelect }) => ($isSelect ? primary[500] : gray.line)} solid;
  background-color: ${({ $isSelect }) => ($isSelect ? primary[100] : "transparent")};
  border-radius: 6px;
  padding: 10px 12px;
`;

const InputRadio = styled.div`
  padding: 0 12px;
  align-self: center;
`;

const WithdrawalBadge = styled.div`
  margin-top: 6px;
  padding: 4px 10px;
  border-radius: 14px;
  max-width: fit-content;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid ${primary[400]};
  background-color: ${primary[100]};
`;

interface ModalFormI {
  keyString?: string;
  value?: any,
  displayValues?: string[]
  options?: any[],
  label?: string,
  isLabelStay?: boolean,
  icon?: ReactNode,
  selectButton?: string,
  changeButton?: string,
  onChange?: (value?: any) => boolean | Promise<boolean> | void,
  error?: {
    message: string,
  }
}

const ModalForm = (props: ModalFormI) => {
  const {
    changeButton = "Ubah",
    displayValues,
    error,
    icon,
    isLabelStay = true,
    keyString = "id",
    label,
    onChange,
    options,
    selectButton = "Pilih",
    value,
  } = props;
  const [isOpen, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState<any>(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const renderDisplayValues = (val: any) => (displayValues) && (
    <>
      {(displayValues[0])
        && <Typography level={5} color={primary[500]} fontWeight="medium">{val[displayValues[0]]}</Typography>
      }
      {(displayValues[1])
        && <Typography level={5} color={gray.subtitle} fontWeight="medium"> • {val[displayValues[1]]}</Typography>
      }
      {(displayValues[2])
        && <><br /><Typography level={7} color={gray.subtitle} fontWeight="medium">{val[displayValues[2]]}</Typography></>
      }
      {(displayValues[3])
        && <Typography level={7} color={gray.bodyText} fontWeight="medium"> • {val[displayValues[3]]}</Typography>
      }
      {(displayValues[4] && val[displayValues[4]]) && (
        <>
          <br />
          <WithdrawalBadge>
            <Typography level={6} color={primary[500]} fontWeight="regular">Withdrawal</Typography>
          </WithdrawalBadge>
        </>
      )}
    </>
  );

  return <>
    <div>
      <Wrapper $isError={!!error}>
        {icon}
        <div>
          {(isLabelStay && value) && <>
            <Typography level={7} color={gray.subtitle} fontWeight="medium">{label}</Typography>
            <br />
          </>}
          {!value && <Typography level={6} color={gray.subtitle} fontWeight="medium">{label}</Typography>}
          {value && renderDisplayValues(value)}
        </div>
        <Button
          size="sm"
          onClick={() => setOpen(true)}
          disabled={!options || options.length === 0}
        >
          {value ? changeButton : selectButton}
        </Button>
      </Wrapper>
      {error && <Typography level={7} color={danger[500]}>{error.message}</Typography>}
    </div>
    <Modal
      title={label || ""}
      isOpen={isOpen}
      setOpen={setOpen}
      footer={
        <>
          <Button
            data-testid="modal-confirm-cancel"
            type="button"
            variant="text"
            onClick={() => {
              setOpen(false);
            }}
          >
            <Typography
              level={5}
              color={BlueBirdTheme.colors.primary[500]}
              fontWeight="bold"
            >
              Batal
            </Typography>
          </Button>
          <Button data-testid="modal-confirm-submit" type="submit" onClick={async () => {
            if (onChange) {
              const isProceed = await onChange(selected);
              if (isProceed || isProceed === undefined) setOpen(false);
            }
          }} >
            <Typography level={5} color="white" fontWeight="bold">
              Simpan
            </Typography>
          </Button>
        </>
      }
      body={<ContainerBox>
        <FilterContent>
          <div style={{ width: "100%" }}>
            <SearchBar
              placeholder="Cari data"
              onInputSearch={setSearch}
            />
          </div>
        </FilterContent>
        <Scrollbar direction="vertical" height={500}>
          <RadioGroup direction="vertical" value={selected?.[keyString]}>
            {options?.filter(
              (item) => JSON.stringify(item).toLowerCase().includes(search.toLowerCase()),
            ).map((item) => (
              <WrapperList key={item[keyString]} onClick={() => setSelected(item)}>
                <InputRadio>
                  <Radio
                    value={item[keyString]}
                    name='akunGl'
                  />
                </InputRadio>
                <WrapperBox $isSelect={item[keyString] === selected?.[keyString]}>
                  {renderDisplayValues(item)}
                </WrapperBox>
              </WrapperList>
            ))}
          </RadioGroup>
        </Scrollbar>
      </ContainerBox >}
    />
  </>;
};

export default ModalForm;
